module.exports = __webpack_public_path__ + "img/gaoxinjishuqiye-tuya.ae734c98.png";